<template>
  <EdroneCard>
    <img
      src="https://d3vhsxl1pwzf0p.cloudfront.net/images_2_6/v2/logo.svg"
      width="100"
      class="center-block tw:mb-5"
      alt="Edrone logo"
    />
    <h4 class="bold text-center">
      {{ $_trans("This account has been suspended") }}
    </h4>
    <p class="text-center tw:mb-3">
      {{ $_trans("The account has been blocked by the administrator") }}
    </p>

    <SuspensionModalButtons @click="goToHelpCentre">
      {{ trans["Contact Us"] }}
    </SuspensionModalButtons>
  </EdroneCard>
</template>

<script setup lang="ts">
import SuspensionModalButtons from "vue-app/components/Suspension/SuspensionModalButtons.vue";
import EdroneCard from "../../../assets/js/ui/EdroneCard.vue";

const goToHelpCentre = () => {
  window.open("https://help.edrone.me/" + window.EDRONE_CONTEXT.user.lang, "_blank");
};
</script>
